import { Card, Group, Avatar, Highlight, Stack } from "@mantine/core"
import { usePersonAttachmentApi } from "../../../../attachment-api/person-attachment-api"
import { PersonDto } from "@/orval/gen"

interface Props {
  person: PersonDto
  globalFilter: string
  onClickItem: (person: PersonDto) => void
}

export function PersonCard({ person, globalFilter, onClickItem }: Props) {
  const avatarSrc = usePersonAttachmentApi().getProfilePictureUrlForPerson(
    person.personId
  )

  return (
    <Card
      key={person.personId}
      shadow="xs"
      style={{ cursor: "pointer" }}
      onClick={() => onClickItem(person)}
      w={"100%"}
    >
      <Group wrap="nowrap">
        <Avatar src={avatarSrc} />
        <Stack gap={0} miw={0}>
          <Highlight
            truncate
            fw={500}
            highlight={globalFilter ?? ""}
            children={
              person.firstName && person.lastName
                ? `${person.firstName} ${person.lastName}`
                : person.firstName
                  ? person.firstName
                  : person.lastName
                    ? person.lastName
                    : ""
            }
          />
          <Highlight highlight={globalFilter ?? ""}>
            {person.categories?.join(",") ?? ""}
          </Highlight>
        </Stack>
      </Group>
    </Card>
  )
}
